import { ICONES_MENSAGEM } from "../utils/icones.jsx";

function PageNotFound() {
  return (
    <div className="m-4">
      <div className="page-not-found">
        <div className="me-2">{ICONES_MENSAGEM.ERRO}</div>
        <span>Página não encontrada</span>
      </div>
    </div>
  );
}

export default PageNotFound;
